const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const ID_RE = /^\d+$/;

const PATTERNS = [
  { prefix: '/patient/', template: '/patient/:id' },
  { prefix: '/visit/', template: '/visit/:id' },
  { prefix: '/reports/', template: '/reports/:id' },
  { prefix: '/edit-document/', template: '/edit-document/:id' },
  { prefix: '/upload-files/', template: '/upload-files/:id' },
  { prefix: '/messages/', template: '/messages/:id' },
  { prefix: '/forms/', template: '/forms/:id' },
];

export function normalizeRoute(rawPath) {
  if (!rawPath) return '/';
  let path = rawPath.split('?')[0].split('#')[0].toLowerCase();
  if (path.length > 1 && path.endsWith('/')) path = path.slice(0, -1);

  for (const { prefix, template } of PATTERNS) {
    if (path.startsWith(prefix)) {
      const rest = path.slice(prefix.length);
      const firstSegment = rest.split('/')[0];
      if (UUID_RE.test(firstSegment) || ID_RE.test(firstSegment)) {
        return template + rest.slice(firstSegment.length);
      }
    }
  }
  return path;
}
